export default "__VITE_ASSET__D0vOit0K__"